import DatePicker from './components/DatePicker';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'datePicker',
  pluginComponent: DatePicker,
});
